<app-modal [isOpen]="isOpen" (close)="onCancel()" className="max-w-md mx-4">
    <div class="p-6">
        <!-- Icon -->
        <!-- La variante 'info' usaba `bg-info-100`/`text-info-600`, y `info` no es una familia
             del tema: el icono salía sin círculo de fondo y sin color. La equivalente real es
             blue-light. -->
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full mb-4"
            [class.bg-error-100]="variant === 'danger'" [class.bg-warning-100]="variant === 'warning'"
            [class.bg-blue-light-100]="variant === 'info'">
            <svg class="h-6 w-6" [class.text-error-600]="variant === 'danger'"
                [class.text-warning-600]="variant === 'warning'" [class.text-blue-light-600]="variant === 'info'" fill="none"
                stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
        </div>

        <!-- Content -->
        <div class="text-center">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-2">
                {{ title }}
            </h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mb-6">
                {{ message }}
            </p>
        </div>

        <!-- Actions -->
        <div class="flex gap-3 justify-center">
            <app-button variant="outline" (btnClick)="onCancel()" [disabled]="loading">
                {{ cancelText }}
            </app-button>
            <app-button [variant]="variant === 'danger' ? 'danger' : 'primary'" (btnClick)="onConfirm()"
                [disabled]="loading">
                @if (loading) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                }
                {{ confirmText }}
            </app-button>
        </div>
    </div>
</app-modal>